import { FolderKanban } from "lucide-react";

const PipelinesIcon = (props) => <FolderKanban strokeWidth={1.5} {...props} />;

export default PipelinesIcon;
